import { CSSObject } from '@emotion/react'
import { fontSizes, fontWeights } from '@opallabs/pulsar'
import { sharedColors } from '../sharedStyles/styles'

const flexRow: CSSObject = {
  display: 'flex',
  flexDirection: 'row',
}

const coverAsset: CSSObject = {
  height: '125px',
  width: '375px',
}

const profileDimensions: CSSObject = {
  borderRadius: '100%',
  height: '61px',
  width: '61px',
}

const profileAsset: CSSObject = {
  ...profileDimensions,
  border: '4px solid white',
  bottom: '25px',
  left: '1px',
  marginBottom: '-59px',
  position: 'relative',
  minBlockSize: '61px !important',
  minInlineSize: '61px !important',
  zIndex: 1000,
  '.kuiper-asset-picker-button-grp': {
    padding: '12px',
  },
  img: {
    ...profileDimensions,
    border: '4px solid white',
  },
}

const profileAssetBase: CSSObject = {
  ...profileDimensions,
  bottom: '25px',
  left: '1px',
  marginBottom: '-51px',
  minBlockSize: '61px !important',
  minInlineSize: '61px !important',
  position: 'relative',
  '.kuiper-asset': {
    border: 'none',
  },
  '.kuiper-asset-info-overlay': {
    borderRadius: '100%',
    left: '5px',
    top: '9px',
    zIndex: 100000,
  },
  '.kuiper-asset-filename': {
    marginTop: '11px',
  },
}

const actionButtonGroup: CSSObject = {
  ...flexRow,
  justifyContent: 'flex-end',
}

const accountName: CSSObject = {
  fontWeight: fontWeights.bold,
  marginTop: '9px',
}

const accountUsername: CSSObject = {
  ...flexRow,
  alignItems: 'center',
  fontSize: fontSizes.xLarge,
  marginTop: '2px',
}

const whiteBtn: CSSObject = {
  ...flexRow,
  alignItems: 'center',
  backgroundColor: 'white',
  border: '1px solid black',
  borderRadius: '100%',
  color: 'black',
  height: '29px',
  justifyContent: 'center',
  marginRight: '9px',
  width: '29px',
}

const blackBtn: CSSObject = {
  ...flexRow,
  alignItems: 'center',
  backgroundColor: sharedColors.black,
  borderRadius: '19px',
  color: 'white',
  fontSize: fontSizes.xSmall,
  fontWeight: fontWeights.bold,
  height: '29px',
  justifyContent: 'center',
  textAlign: 'center',
  width: '100px',
}

const profile: CSSObject = {
  padding: '0 18px 13px 18px',
}

const getBio: CSSObject = {
  fontSize: fontSizes.large,
  margin: '12px 0 2px -5px',
}

const footerWrapper: CSSObject = {
  ...flexRow,
  alignItems: 'center',
  color: sharedColors.medGray,
  flexWrap: 'wrap',
  fontSize: fontSizes.small,
  maxWidth: '339px',
}

const footerItem: CSSObject = {
  ...flexRow,
  alignItems: 'flex-start',
  margin: '0 5px 5px 0',
  '.kuiper-icon-wrapper': {
    margin: '5px 2px 0 0',
  },
}

const getFooterInput = (inputType: string): CSSObject => ({
  color: sharedColors.medGray,
  fontSize: fontSizes.small,
  maxHeight: inputType === 'url' ? '37px' : '23px',
  maxWidth: '320px',
  minWidth: inputType === 'url' ? '134px !important' : '105px !important',
})

const socialLinkStyle: CSSObject = {
  '.social-link-match': {
    color: sharedColors.blue,
  },
}

const footerInputStyle: CSSObject = {
  padding: '2px',
  ...socialLinkStyle,
}

const joinedWrapper: CSSObject = {
  ...flexRow,
  margin: '5px 0 0 5px',
}

const styles = {
  accountName,
  accountUsername,
  actionButtonGroup,
  blackBtn,
  coverAsset,
  footerInputStyle,
  footerItem,
  footerWrapper,
  getBio,
  getFooterInput,
  joinedWrapper,
  profile,
  profileAsset,
  profileAssetBase,
  socialLinkStyle,
  whiteBtn,
}

export { styles }
